import { useEffect, useState } from 'react';
export const usePrefersColorScheme = (light, dark) => {
    const [systemPrefersDark, setSystemPrefersDark] = useState();
    useEffect(() => {
        function isSystemDark(event) {
            setSystemPrefersDark(event.matches);
        }
        if (typeof window !== 'undefined') {
            const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
            if (mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) {
                mediaQuery.addEventListener('change', isSystemDark);
            }
            else {
                mediaQuery.addListener(isSystemDark);
            }
            return () => {
                if (mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) {
                    mediaQuery.removeEventListener('change', isSystemDark);
                }
                else {
                    mediaQuery.removeListener(isSystemDark);
                }
            };
        }
    }, []);
    return {
        theme: systemPrefersDark ? dark : light,
        mode: systemPrefersDark ? 'dark' : 'light',
    };
};
//# sourceMappingURL=usePrefersColorScheme.js.map